<template>
  <span class="section-menu" v-click-outside="closeMenu">
     <div class="action" v-on:click="emitOpenEditTrackingCategoryAmountPopup" v-on:focusout="closeMenu">
      <img class="icon" :src="require('@/assets/icons/gray-pencil.svg')">
      <span class="action-text">עריכת סכום</span>
    </div>
    <div class="action" v-on:click="emitOpenCancelTrackingCategoryConfirmationPopup" v-on:focusout="closeMenu">
      <img class="icon" :src="require('@/assets/icons/gray-trash.svg')">
      <span class="action-text">מחיקה מהתזרים</span>
    </div>
  </span>
</template>

<script>
import { mapActions } from 'vuex';
import EditAmountPopup
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/EditAmountPopup';
import Segment from '../../../../../../../../../../Segment';
import ClickOutside from '../../../../../../../../../../directives/click-outside';
import CancelTrackingCategoryConfirmationPopup from './CancelTrackingCategoryConfirmationPopup.vue';

export default {
  name: 'TrackingCategorySectionMenu',
  directives: {
    ClickOutside,
  },
  props: {
    categoryName: {
      type: String,
      required: true,
    },
    category: {
      type: Object,
      required: true,
    },
    envelopeId: {
      type: String,
      required: true,
    },
    upToNowAmount: {
      type: Number,
      required: true,
    },
    closeMenu: {
      type: Function,
      required: true,
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    emitOpenCancelTrackingCategoryConfirmationPopup() {
      Segment.trackUserInteraction('SectionMenu_CancelTrackingCategoryClicked', {
        trackingCategory: this.categoryName,
      });
      this.openModal({
        component: CancelTrackingCategoryConfirmationPopup,
        props: {
          trackingCategory: this.categoryName,
          categoryId: this.category.categoryId,
          envelopeId: this.envelopeId,
          upToNowAmount: this.upToNowAmount,
        },
      });
    },
    emitOpenEditTrackingCategoryAmountPopup() {
      Segment.trackUserInteraction('SectionMenu_EditTrackingCategoryAmountClicked', {
        trackingCategory: this.categoryName,
      });
      this.openModal({
        component: EditAmountPopup,
        props: {
          expenseCategory: this.categoryName,
          category: this.category,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .section-menu {
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 8px;
    box-shadow: 2px 2px 8px 0 $riseup_gray_0;
    background-color: $riseup_white;
    padding: 24px 24px 4px;

    .action {
      display: flex;
      cursor: pointer;
      padding-bottom: 20px;

      .icon {
        width: 15px;
        height: 15px;
        margin-left: 15px;
      }

      .action-text {
        font-family: SimplerPro;
        font-size: 14px;
      }
    }
  }
</style>
